import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction'
import ListItemText from '@mui/material/ListItemText'
import Switch from '@mui/material/Switch'
import React, { Fragment } from 'react'
import { PublicTransportStationFeature } from '@digimap/types'
import CityMapperLink from '../../../components/CityMapper/CityMapperLink'

interface PublicTransportSuggestionsListProps {
  stations: PublicTransportStationFeature[]
  selected: PublicTransportStationFeature[]
  onAdd: (selected: PublicTransportStationFeature) => void
  onRemove: (selected: PublicTransportStationFeature) => void
}

export default function PublicTransportSuggestionsList(
  props: PublicTransportSuggestionsListProps
) {
  const { stations } = props

  return (
    <List>
      {stations.map((feature) => {
        const isSelected = props.selected.some(
          (s) => s.properties._id === feature.properties._id
        )
        return (
          <Fragment key={feature.properties.name}>
            <ListItem>
              <ListItemText
                id={`neareast-stations-${feature.properties.name}`}
                primary={<CityMapperLink feature={feature} type='outbound' />}
                secondary={`${feature.properties.line} / ${
                  feature.properties.dist
                    ? Math.round(feature.properties.dist * 100) / 100
                    : '??'
                } km`}
              />
              <ListItemSecondaryAction>
                <Switch
                  edge='end'
                  onChange={(
                    e: React.ChangeEvent<HTMLInputElement>,
                    checked: boolean
                  ) => {
                    if (!checked) {
                      props.onRemove(feature)
                    } else {
                      props.onAdd(feature)
                    }
                  }}
                  checked={isSelected}
                  inputProps={{
                    'aria-labelledby': `neareast-stations-${feature.properties.name}`,
                  }}
                />
              </ListItemSecondaryAction>
            </ListItem>
          </Fragment>
        )
      })}
    </List>
  )
}
